import { callApiToServer } from "../callApi";

export async function editSubCategory(authtoken, subCategoryObject) {
  try {
    let header = {
      Accept: "application/json",
      "Content-Type": "application/json",
      authorization: "Berear " + authtoken,
    };

    let body = JSON.stringify(subCategoryObject);

    console.log(body);

    let endUrl = "v1/auth/admin/edit-sub-category";
    console.log("endUrl printed here", endUrl);

    let responseData = await callApiToServer(body, header, "PUT", endUrl);

    return responseData;
  } catch (err) {
    throw err;
  }
}
